<!-- card in searchResults with nested-links or so-called layered-links -->
<!-- 1) Basic elements:
Box doesn't need an extra class. The Link in the title element MUST have the class="title-anchor".
If class is missing layered links aren't working but the box is still working -->
<!-- 2) Interactive elements (e.g. badges, SEO-Links):
If you want an element to be clickable it MUST have the class="clickable-element" OR be an <a>-tag, <button>-tag)
otherwise the element itself belongs to the link of the whole box -->
<!-- 3) Noninteractive elements (e.g. details, price):
Beside of that the outest element (the box) MUST be the only element that is position:relative so every whitespace is clickable.
That means bootstrap grid system elements MUST have the class="no-relative-position" if the element belongs to the whole box -->
<template>
  <div>
    <div
      :id="'listObject-'+searchObject.objectNumber"
      ref="listObject"
      :title="searchObject.title"
      class="search-list-object"
      :class="[{ recommendation: searchObject.objectPush ,'free-cancellation':cancelable}]"
      @mouseover.prevent="hover = searchObject.objectNumber"
      @mouseleave.prevent="hover = false"
      @focusin.prevent="hover = searchObject.objectNumber"
      @focusout.prevent="hover = false"
    >
      <div class="row row-no-pad">
        <div class="col-md-4">
          <div
            v-if="searchObject.objectImages && searchObject.objectImages.length"
            class="img clickable-element"
          >
            <gallery-slider-custom
              :key="searchObject.objectNumber + '_slider'"
              :images-arr="sliderCustomImages"
              :image-count-full="imageCountFull"
              :wrapper="'gallery gallery-object'"
              :share="false"
              :gallery-link="{
                path: searchObject.seoLinkObject,
                query: {
                  ...searchFilterObjectQuery,
                }
              }"
              :image-type="'objectDefault'"
              :object-number="searchObject.objectNumber"
              @click="$store.commit('SET_SEARCH_LASTCLICKEDOBJECTNUMBER', searchObject.objectNumber)"
            />
            <!-- peter says it has to be temporary disabled -->
            <agency-logo
              v-if="false && searchObject.agency > 0"
              :agency-number="searchObject.agency"
              :template="'agencyLogoSearch'"
            />

            <!-- drop agency partner cookie if agency brand is visible -->
            <agency-cookie-drop
              v-if="withCookieDropping"
              :agency-number="searchObject.agency"
            />
          </div>
          <div class="object-options">
            <watch-btn
              :object-number="searchObject.objectNumber"
              :price-object="priceObject"
              :min-price="searchObject.minPrice"
              :extra-class="'watch-btn-search'"
            />
          </div>
        </div>
        <div class="col-md-8 no-relative-position">
          <div class="content">
            <div class="row">
              <div class="col-sm-8 col-lg-6 col-xl-8 no-relative-position">
                <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
                <h3 class="title">
                  <a
                    v-dompurify-html="searchObject.title"
                    class="title-anchor"
                    :href="arp_linkBuilder({ path: searchObject.seoLinkObject, query: {...searchFilterObjectQuery }})"
                    @click.prevent="arp_linkClicker({ path: searchObject.seoLinkObject, query: {...searchFilterObjectQuery }})"
                    @click="$store.commit('SET_SEARCH_LASTCLICKEDOBJECTNUMBER', searchObject.objectNumber)"
                  />
                </h3>
                <div
                  v-if="!groupFilterActive && searchObject.objectGroupKeyCount && searchObject.objectGroupKeyCount > 0"
                  class="group-filter-link"
                >
                  <a
                    :href="arp_linkBuilder({ name: 'Search', query: searchFilterCollapseQuery})"
                    @click.prevent="arp_linkClicker({ name: 'Search', query: searchFilterCollapseQuery})"
                  >
                    <i class="icon"><icon-plus-alternative /></i>
                    <!-- {{ $t('object:collapse', {count: searchObject.objectGroupKeyCount}) }} -->
                    {{ $t('object:collapseObjects') }}
                  </a>
                </div>
                <stv-dtv-rating
                  v-if="searchObject.objectSTV > 0"
                  method="STV"
                  :num-stars="searchObject.objectSTV"
                  :object-number="searchObject.objectNumber"
                />
                <stv-dtv-rating
                  v-if="searchObject.objectDTV > 0"
                  method="DTV"
                  :num-stars="searchObject.objectDTV"
                  :object-number="searchObject.objectNumber"
                />

                <search-object-basics
                  :object-data="searchObject"
                />
                <search-object-location
                  :add-search-query="!$store.state.isOfferLandingPage"
                  :object-data="searchObject"
                  :add-link="addLocationLink"
                />
                <search-object-rating-snippet
                  :object-data="searchObject"
                />
                <search-aexea
                  v-if="!hideAexeaTexts && searchObject.descriptionsAexea && searchObject.descriptionsAexea.search"
                  class="d-xs-block d-sm-none"
                  :aexea-teaser="searchObject.descriptionsAexea.search"
                />
                <div class="d-none">
                  {{ searchObject.searchFilter }}
                </div>
                <div class="badges badges-sm">
                  <search-partner-tags
                    :object-data="searchObject"
                  />
                  <search-offer
                    :ids="searchObject.searchOffers"
                  />
                </div>
              </div>
              <div class="col-sm-4 col-lg-6 col-xl-4 pl-sm-0 no-relative-position">
                <div class="row row-tight">
                  <search-object-rating-summary
                    :object-data="searchObject"
                  />
                  <div class="col-6 col-sm-12 no-relative-position">
                    <div
                      v-if="priceObject.price > 0 && priceObject.price < 999999"
                      class="price"
                    >
                      <div v-if="false">
                        <del>{{ Math.round(Math.random()*1000) }} €</del>
                        <b-badge variant="discount">
                          -33%
                        </b-badge>
                      </div>

                      <object-price-original
                        :price="priceObject.price"
                        :original="priceObject.original"
                        :price-percent-reduction="priceObject.pricePercentReduction"
                        :currency="priceObject.currency"
                        :show-off="true"
                        :no-decimals="true"
                      />
                      <small>
                        <object-price-duration
                          :duration="priceObject.priceDuration"
                          :end-date-string="endDateString"
                          :start-date-string="startDateString"
                          :show-start-and-end-date="showStartAndEndDate"
                          :changed-travel-coditions="priceObject.changedTravelCoditions"
                        />
                      </small>
                    </div>
                    <div class="cta">
                      <button
                        class="btn btn-primary btn-block btn-sm"
                        type="button"
                        aria-hidden="true"
                        @click="arp_linkClicker({ path: searchObject.seoLinkObject, query: {...searchFilterObjectQuery }})"
                      >
                        {{ $t('common:objectDetailsBtn') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-sm-block">
        <div
          v-if="searchObject.ratingSnippet"
          class="excerpt"
        >
          <i class="icon"><icon-user class="svg-icon svg-fill" /></i>
          "{{ searchObject.ratingSnippet }}"
        </div>
        <search-aexea
          v-if="!hideAexeaTexts && searchObject.descriptionsAexea && searchObject.descriptionsAexea.search"
          class="d-xs-none d-sm-block"
          :aexea-teaser="searchObject.descriptionsAexea.search"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from '@vue/composition-api';
/** CONFIG  */
import agencyCookies from 'config/cookieDrop';
import flags from 'config/components/search/flags';

import AnchorRouterPush from 'mixins/AnchorRouterPush';
import StateProviderSetup from 'mixins/composition/search/StateProvider';
import { getReducedCtx } from 'mixins/composition/search/index';
import hydrationPreventionSetup from 'mixins/composition/search/HeaderSearchHydrationPrevention';

import { getClearedFilter } from 'utils/SearchFilterHelper';
import StvDtvRating from 'components/StvDtvRating.vue';
import SearchOffer from 'components/SearchOffer.vue';
import SearchPartnerTags from 'components/SearchPartnerTags.vue';
import AgencyLogo from 'components/AgencyLogo.vue';
import AgencyCookieDrop from 'components/AgencyCookieDrop.vue';
import SearchObjectBasics from 'components/SearchObjectBasics.vue';
import SearchObjectLocation from 'components/SearchObjectLocation.vue';
import SearchObjectRatingSnippet from 'components/SearchObjectRatingSnippet.vue';
import SearchObjectRatingSummary from 'components/SearchObjectRatingSummary.vue';
import SearchAexea from 'components/SearchAexea.vue';
import ObjectPriceDuration from 'components/ObjectPriceDuration.vue';
import ObjectPriceOriginal from 'components/ObjectPriceOriginal.vue';
import WatchBtn from 'components/WatchBtn.vue';
import { fromAPIDateString, toDateString } from 'utils/DateHelper';
import { mapMutations } from 'vuex';
import { BBadge } from 'bootstrap-vue';

import IconUser from 'ICON:IconUser';
import IconPlusAlternative from 'ICON:IconPlusAlternative';
/**
 *

                      <!-- took out of objectprice per week
                      :has-date="hasDate" -->
                      <object-price-original
                        v-if="hasDate"
                        :price="priceObject.price"
                        :original="priceObject.original"
                        :currency="priceObject.currency"
                        :price-complete="priceObject.priceComplete"
                        :show-off="true"
                      />
                      <small v-if="startDateString !== '' && endDateString !== ''">
                        <object-price-duration
                          :lang-key="langWeekDays"
                          :lang-count="langDuration"
                          :end-date-string="endDateString"
                          :start-date-string="startDateString"
                        />
                      </small>
 *
 */
/**
 *
 * @@author        ???
 * @@date          ???
 * @@desc          Renders an object inside the search objects list
 * @@usedby        Search --> SearchObjectList
 *
 */

export default {
  name: 'SearchObject',
  components: {
    StvDtvRating,
    SearchOffer,
    // ObjectPricePerWeek,
    ObjectPriceDuration,
    ObjectPriceOriginal,
    AgencyLogo,
    AgencyCookieDrop,
    SearchObjectBasics,
    SearchObjectLocation,
    SearchObjectRatingSnippet,
    SearchObjectRatingSummary,
    SearchAexea,
    BBadge,
    GallerySliderCustom: () => import(/* webpackChunkName: "gallery-slider-custom" */ 'components/GallerySliderCustom.vue'),
    IconUser,
    WatchBtn,
    SearchPartnerTags,
    IconPlusAlternative,
  },
  mixins: [AnchorRouterPush],
  props: {
    searchObject: {
      required: true,
      type: Object,
    },
    searchStartDate: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    const { dispatchMountSignal } = hydrationPreventionSetup(ctx.root.$store, ctx.root, ctx.refs);
    onMounted(() => { dispatchMountSignal('searchObjects'); });
    const { isSeoPage } = StateProviderSetup(getReducedCtx(ctx));
    return { isSeoPage };
  },
  data() {
    return {
      hover: false,
      agencyCookies,
      hasOffer: false,
    };
  },
  computed: {
    addLocationLink() {
      // do not add location hrefs if config addLocationLinks is false
      return flags.addLocationLinks;
    },
    // builds the price object needed for price display from the search object data
    priceObject() {
      return {
        currency: this.$t('common:currency'),
        original: ((this.searchObject.priceOriginal) ? this.searchObject.priceOriginal : 0),
        price: ((this.searchObject.price) ? this.searchObject.price : null),
        pricePercentReduction: ((this.searchObject.pricePercentReduction) ? this.searchObject.pricePercentReduction : 0),
        startDate: ((typeof this.searchObject.startDate === 'undefined') ? null : this.searchObject.startDate),
        endDate: ((typeof this.searchObject.endDate === 'undefined') ? null : this.searchObject.endDate),
        duration: this.searchObject.duration,
        priceDuration: this.searchObject.priceDuration,
        persons: ((typeof this.searchObject.persons === 'undefined') ? null : this.searchObject.persons),
        changedTravelCoditions: ((typeof this.searchObject.changedTravelCoditions === 'undefined') ? null : this.searchObject.changedTravelCoditions),
      };
    },
    // does the search object have a valid date?
    hasDate() {
      return this.priceObject.startDate !== null
             && this.priceObject.endDate !== null
             && this.priceObject.endDate !== this.priceObject.startDate;
    },
    // calculates the count of days or weeks needed to build the translation
    langDuration() {
      return this.priceObject.duration % 7 === 0
        ? this.priceObject.duration / 7
        : this.priceObject.duration;
    },
    // returns the localized start date string depending on the price data
    startDateString() {
      const startDateStringSave = this.priceObject.startDate ? toDateString(fromAPIDateString(this.priceObject.startDate)) : '';
      return startDateStringSave.toString();
    },
    // returns the localized end date string depending on the price data
    endDateString() {
      const endDateStringSave = this.priceObject.endDate ? toDateString(fromAPIDateString(this.priceObject.endDate)) : '';
      return endDateStringSave.toString();
    },
    // returns search filter url query for object link (returntype is object {})
    searchFilterObjectQuery() {
      // create new object to leave this.priceObject untouched
      let searchFilter = JSON.parse(JSON.stringify(this.priceObject));
      searchFilter = getClearedFilter(searchFilter, [], ['startDate', 'endDate', 'persons']);
      if (this.searchObject?.perfectMatch && this.searchObject.perfectMatch === 'N') {
        searchFilter = Object.assign(searchFilter, { pm: 'N' });
      }
      return searchFilter;
    },
    sliderCustomImages() {
      // EDVUE-2837 show all images in slider
      // return this.searchObject.objectImages?.slice(0, 10) || [];
      return this.searchObject.objectImages || [];
    },
    imageCountFull() {
      return this.searchObject.objectImages.length;
    },
    hideAexeaTexts() {
      return !this.isSeoPage;
    },
    showStartAndEndDate() {
      // EDVUE-708 show start and enddate on lastminute search
      return this.$store.getters.getSearchFilter('lastminuteonly') === 1 || this.priceObject.changedTravelCoditions === 'Y' || this.$store.getters.getSearchFilter('duration') > 0;
    },
    cancelable() {
      return (this.$store.getters.isCancelable(this.searchObject.objectNumber));
    },
    withCookieDropping() {
      return agencyCookies.some((agency) => agency.agencyNumber === this.agencyId);
    },
    searchFilterCollapseQuery() {
      const collapseQuery = { ...this.$store.getters.getMergedTerms, group: this.searchObject.objectGroupKey };
      /*
      const allowedGroupLinkParams = ['startDate', 'endDate', 'duration', 'tolerance', 'group'];
      delete collapseQuery.page;
      Object.keys(collapseQuery)
        .filter((key) => !allowedGroupLinkParams.includes(key))
        .forEach((key) => delete collapseQuery[key]);
      */
      delete collapseQuery.page;
      return collapseQuery;
    },
    groupFilterActive() {
      const activeFilter = { ...this.$store.getters.getMergedTerms };
      // if value is undefined this will return false
      return (!!(activeFilter.group));
    },
  },
  watch: {
    hover: {
      handler: 'highlight',
    },
  },
  mounted() {
    // scroll to last viewed object because lazy load breaks scrollBehavior
    if (this.searchObject.objectNumber === this.$store.state.search.lastClickedObjectNumber && this.$store.state.app.router.navigationFromPopstate) {
      this.$refs.listObject.scrollIntoView();
      this.$nextTick(() => {
        window.scrollTo({
          top: window.scrollY - 200,
        });
      });
    }
  },
  methods: {
    ...mapMutations({ toggleHighlight: 'TOGGLE_HIGHLIGHT' }),
    highlight(target) {
      // this.$refs.listObject.classList.toggle('active');
      this.toggleHighlight({ objectNumber: target });
    },
  },
  i18nOptions: { namespaces: ['object', 'common', 'rating'] },
};
</script>

<style lang="scss" src="scss/components/ListObject.scss" scoped></style>
<style lang="scss" scoped>
  .search-list-object {
    &.recommendation {
      border-color: var(--color_recommendation);
      border-width: var(--border_width_recommendation);

      @media #{$media_xs} {
        border: none;

        .img {
          border: 3px solid var(--color_recommendation);
          border-left: none;
          border-right: none;
        }
      }
    }
  }

.group-filter-link {
  font-size: .9em;
  line-height: 1.2em;
  margin: .5em 0;
  padding: 0;
  color: var(--color_ci_complement);
  #app:not(.isTouchDevice) &:hover{
    color: var(--color_ci_complement);
  }
}
</style>
